const ConditionalWrapper = ({ condition, children, ...props }) => {
  if (condition)
    return props.wrapper(children);
  if (!condition && props.falseWrapper)
    return props.falseWrapper(children);
  return children;
};
export {
  ConditionalWrapper
};
